<template>
	<BaseContenedor>
		<BaseBuscar v-model="filter" @enter="filtrar">
			<BaseButton
				v-puede-disabled="[roles.Administrador]"
				style-button="danger"
				style-class="right floated"
				:disabled="aspirantes.length === 0"
				@click="onEliminar"
			>
				<i class="trash icon"></i>
				Eliminar
			</BaseButton>
			<BaseButton
				v-puede-disabled="[roles.Administrador]"
				style-class="right floated positive"
				@click="toggleModalArchivo"
			>
				<i class="plus icon"></i>
				Importar
			</BaseButton>
			<BaseButton
				v-puede-disabled="[roles.Administrador]"
				style-button="primary"
				style-class="right floated"
				@click="toggleModalAgregar"
			>
				<i class="plus icon"></i>
				Agregar
			</BaseButton>
		</BaseBuscar>
		<AsignarExamen
			ref="exam"
			v-model="asociacion"
			:loading="getLoadingAction"
			@guardar="onAsignarExamen"
		></AsignarExamen>
		<BaseModalArchivo
			ref="modal-archivo"
			v-model="files"
			titulo="Importar Aspirantes"
			:plantilla="plantilla"
			:loading="getLoadingAction"
			plantilla-descripcion="Descargue el formato CSV para agregar nuevos aspirantes."
			acepta=".csv"
			@close="toggleModalArchivo"
			@aceptar="subirArchivos"
		/>
		<AgregarAspirante
			ref="modalAgregar"
			v-model="aspirante"
			:editar="editar"
			:loading="getLoadingAction"
			@guardar="onCrear"
			@editar="onEditar"
		></AgregarAspirante>
		<BaseModalRestablecerContrasenia
			ref="modalRestablecer"
			:loading="getLoadingAction"
			:descripcion="descripcionModalRestablecer"
			@guardar="onRestablecerContra"
			@close="limpiarModalRestablecer"
		></BaseModalRestablecerContrasenia>
		<BaseTabla
			ref="table"
			:campos="campos"
			:elementos="aspirantes"
			:pagina-actual="paginaActual"
			:loading="getLoading"
			:elemento="elemento"
			tipo="selectable"
			actions
			:filtro="filter"
			@cambiarPagina="cambiarPagina"
			@onSeleccionar="onSelectRow"
		>
			<template slot="TITLE_ITEM">
				Detalles del Aspirante
			</template>
			<template slot="BODY_ITEM" slot-scope="{ item }">
				<div v-if="item">
					<base-mostrar-dato titulo="Ficha" :valor="item.ficha" />
					<base-mostrar-dato
						titulo="Nombre completo"
						:valor="item.nombreCompleto"
					/>
					<base-mostrar-dato
						titulo="Carrera"
						:valor="`${item.claveCarrera} ${item.nombreCarrera}`"
					/>
					<base-mostrar-dato
						titulo="Exámen asignado"
						:valor="item.claveExamen"
					/>
					<base-mostrar-dato
						titulo="Fecha y hora inicio"
						:valor="item.fechaYHoraInicio || '-'"
					/>
					<base-mostrar-dato titulo="CURP" :valor="item.curp || '-'" />
					<base-mostrar-dato
						titulo="Correo Electrónico"
						:valor="item.correoElectronico || '-'"
					/>
					<base-mostrar-dato
						titulo="Bloqueado"
						:valor="item.bloqueado ? 'SI' : 'NO'"
					/>
				</div>
			</template>
			<template slot="action" slot-scope="{ item }">
				<div
					v-puede="[roles.Administrador]"
					style="text-align:right;"
					@click.stop
				>
					<i
						class="icon iconAction file alternate outline"
						title="Asignar exámen"
						@click="clickAsignarExamen(item)"
					></i>
					<i
						class="icon iconAction sync alternate"
						title="Restablecer Contraseña"
						@click="clickContrasenia(item)"
					></i>
					<i
						class="icon iconAction edit"
						title="Editar"
						@click="clickEditar(item)"
					></i>
					<i
						class="icon iconAction trash"
						title="Eliminar"
						@click="clickEliminar(item)"
					></i>
					<i
						v-show="item.bloqueado"
						class="icon iconAction unlock "
						title="Desbloqear"
						@click="clickDesbloquear(item)"
					></i>
					<i
						v-show="!item.bloqueado"
						class="icon iconAction lock"
						title="Bloquear"
						@click="clickBloquear(item)"
					></i>
				</div>
			</template>
			<template slot="EMPTY">Sin aspirantes registrados.</template>
			<template slot="EMPTY_FILTER">Sin registros para mostrar.</template>
		</BaseTabla>
	</BaseContenedor>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import Notification from '@utils/notification';
import Rols from '@constants/roles';
import AsignarExamen from './asignar-examen.vue';
import AgregarAspirante from './agregar-aspirante.vue';

export default {
	page: {
		title: 'Aspirantes',
		meta: [{ name: 'description', content: 'The Aspirantes page.' }]
	},
	components: { AsignarExamen, AgregarAspirante },
	data: function() {
		return {
			paginaActual: 1,
			files: [],
			elemento: null,
			campos: {
				ficha: { nombre: 'Ficha', class: 'wide one' },
				nombreCompleto: { nombre: 'Nombre completo', class: 'wide four' },
				nombreCarrera: { nombre: 'Carrera', class: 'wide three' },
				curp: { nombre: 'C.U.R.P.', class: 'wide three' },
				examenAsignado: { nombre: 'Exámen asignado', class: 'wide three' },
				estatus: { nombre: 'Estatus', class: 'wide two' }
			},
			filter: '',
			roles: Rols,
			asociacion: {},
			aspirante: {},
			editar: false,
			aspiranteSeleccionado: '',
			descripcionModalRestablecer: ''
		};
	},
	computed: {
		...mapGetters('aspirantes', [
			'getAspirantes',
			'getAspirante',
			'getLoading',
			'getLoadingAction'
		]),
		...mapGetters('plantillas', ['getPlantillas']),
		plantilla: function() {
			return this.getPlantillas.CAT_ASPIRANTES;
		},
		aspirantes: function() {
			return this.getAspirantes.map(
				({
					plantel,
					ficha,
					nombreCompleto,
					curp,
					claveExamen,
					correoElectronico,
					bloqueado,
					claveCarrera,
					nombreCortoCarrera,
					fechaYHoraInicio
				}) => ({
					plantel,
					ficha,
					nombreCompleto,
					curp,
					correoElectronico,
					bloqueado,
					fechaYHoraInicio,
					estatus: bloqueado ? 'BLOQUEADO' : 'ACTIVO',
					claveCarrera,
					nombreCarrera: nombreCortoCarrera || '-',
					examenAsignado: claveExamen
						? `${claveExamen}(${fechaYHoraInicio})`
						: '-',
					claveExamen
				})
			);
		}
	},
	watch: {
		filter: function(value) {
			if (this.paginaActual !== 1) this.paginaActual = 1;
		},
		getLoadingAction: function(value, old) {
			this.$confirm(null, value);
		}
	},
	mounted() {
		this.establecerTitulo('Aspirantes');
		this.establecerUrlAtras('/catalogos');
		this.inicializar();
	},
	beforeDestroy() {
		this.limpiar();
	},
	methods: {
		...mapActions('aspirantes', [
			'inicializar',
			'limpiar',
			'subirArchivoCsv',
			'obtenerElemento',
			'eliminarTodos',
			'crearAspirante',
			'editarAspirante',
			'eliminarAspirante',
			'restablecerContraseniaAspirante',
			'establecerAspirante',
			'bloquearAlAspirante',
			'desbloquearAlAspirante'
		]),
		...mapActions('examenAspirantes', ['asignarExamenAspirante']),
		...mapActions('app', ['establecerTitulo', 'establecerUrlAtras']),
		toggleModalArchivo() {
			this.$refs.table.ocultarElemento();
			this.$refs['modal-archivo'].toggle();
		},
		closeModalArchivo() {
			this.$refs['modal-archivo'].close();
		},
		onSelectRow(row) {
			this.$refs.table.ocultarElemento();
			this.elemento = row;
			this.$refs.table.mostrarElemento();
		},
		onEliminar() {
			this.$refs.table.ocultarElemento();
			this.$confirm({
				title: 'Eliminar aspirantes',
				message: '¿Desea eliminar los aspirantes?',
				description: 'Esta opción no se puede deshacer.',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.eliminarTodos({
						onComplete: () => {
							closeModal();
							Notification('success', '¡Aspirantes eliminados con éxito!');
						},
						onError: () =>
							Notification('error', 'Error al eliminar los aspirantes')
					});
					setTimeout(() => this.inicializar(), 2000);
				},
				callbackCancelar: () => {}
			});
		},
		subirArchivos() {
			if (this.files.length > 0) {
				this.cambiarPagina(1);
				this.subirArchivoCsv({
					archivos: this.files[0],
					onComplete: () => {
						Notification('info', 'Procesando información');
						this.closeModalArchivo();
						setTimeout(() => this.inicializar(), 2000);
					}
				});
				Vue.set(this, 'files', []);
			}
		},
		cambiarPagina(paginaActual) {
			this.paginaActual = paginaActual;
		},
		filtrar(filtro) {},
		clickAsignarExamen(aspirante) {
			Vue.set(this, 'asociacion', {
				ficha: aspirante.ficha || null,
				claveExamen: aspirante.claveExamen || null,
				fechaYHoraInicio: aspirante.fechaYHoraInicio || null
			});
			this.$refs.exam.toggle();
		},
		onAsignarExamen(asociacion) {
			this.asignarExamenAspirante({
				ficha: asociacion.ficha,
				data: {
					clave: asociacion.claveExamen,
					fechaYHoraInicioExamen: asociacion.fechaYHoraInicio
				},
				onComplete: () => {
					this.$refs.exam.toggle();
					Notification('success', '¡Exámen asociado con éxito!');
					setTimeout(() => this.inicializar(), 1000);
				}
			});
		},
		toggleModalAgregar() {
			this.editar = false;
			this.$refs.modalAgregar.toggle();
		},
		onCrear() {
			this.crearAspirante({
				params: this.aspirante,
				onComplete: () => {
					this.$refs.modalAgregar.close();
					Notification('success', '¡Aspirante creado con éxito!');
					setTimeout(() => this.inicializar(), 1000);
				}
			});
		},
		clickEditar(asp) {
			this.establecerAspirante(asp);
			this.editar = true;
			this.$refs.modalAgregar.toggle();
		},
		onEditar() {
			this.editarAspirante({
				ficha: this.aspirante.ficha,
				params: this.aspirante,
				onComplete: () => {
					this.$refs.modalAgregar.close();
					Notification('success', '¡Aspirante modificado con éxito!');
					setTimeout(() => this.inicializar(), 1000);
				}
			});
		},
		clickEliminar(aspirante) {
			this.$confirm({
				title: 'Eliminar aspirante',
				message: '¿Desea eliminar el aspirante seleccionado?',
				description: 'Esta opción no se puede deshacer.',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.eliminarAspirante({
						ficha: aspirante.ficha,
						onComplete: () => {
							closeModal();
							Notification('success', '¡Aspirante eliminado con éxito!');
						}
					});
					setTimeout(() => this.inicializar(), 1000);
				},
				callbackCancelar: () => {}
			});
		},
		clickContrasenia(item) {
			this.aspiranteSeleccionado = item.ficha;
			this.descripcionModalRestablecer = `${item.ficha} - ${item.nombreCompleto}`;
			this.$refs.modalRestablecer.toggle();
		},
		limpiarModalRestablecer() {
			this.aspiranteSeleccionado = '';
			this.descripcionModalRestablecer = '';
		},
		onRestablecerContra(contra) {
			this.restablecerContraseniaAspirante({
				ficha: this.aspiranteSeleccionado,
				params: { contrasenia: contra },
				onComplete: () => {
					this.$refs.modalRestablecer.close();
					Notification('success', '¡Contraseña restablecida con éxito!');
					setTimeout(() => this.inicializar(), 1000);
				}
			});
		},
		clickBloquear(aspirante) {
			this.$confirm({
				title: 'Bloquear aspirante',
				message: '¿Desea bloquear el aspirante seleccionado?',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.bloquearAlAspirante({
						folio: aspirante.ficha,
						onComplete: () => {
							closeModal();
							setTimeout(() => this.inicializar(), 1000);
						}
					});
				},
				callbackCancelar: () => {}
			});
		},
		clickDesbloquear(aspirante) {
			this.$confirm({
				title: 'Desbloquear aspirante',
				message: '¿Desea desbloquear el aspirante seleccionado?',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.desbloquearAlAspirante({
						folio: aspirante.ficha,
						onComplete: () => {
							closeModal();
							setTimeout(() => this.inicializar(), 1000);
						}
					});
				},
				callbackCancelar: () => {}
			});
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
</style>
